import React from "react";

// Deterministic pastel from name so avatars feel consistent
const PALETTE = [
  ["#A7B89A", "#4E6554"], // sage / forest
  ["#D8CEC3", "#4E6554"], // taupe / forest
  ["#C6A56A", "#4E6554"], // gold / forest
  ["#4E6554", "#FAF7F2"], // forest / linen
];

function pick(name = "") {
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  return PALETTE[hash % PALETTE.length];
}

function initials(name = "") {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((n) => n[0].toUpperCase())
    .join("") || "S";
}

export default function InitialAvatar({ name, size = 56, className = "" }) {
  const [bg, fg] = pick(name);
  return (
    <div
      className={`rounded-full flex items-center justify-center font-serif shrink-0 border border-taupe ${className}`}
      style={{ width: size, height: size, background: bg, color: fg, fontSize: size * 0.4 }}
      aria-label={name}
    >
      {initials(name)}
    </div>
  );
}
